// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_p5-0";